import React from "react";
import { SEO } from "../components/seo";

function App() {
  return (
    <>
      <SEO
        title="Support - League Life | Contact & Help"
        description="Get help with League Life. Contact our support team for technical issues, questions, or feedback about our athlete lifestyle services."
        canonicalUrl="https://leaguelife.com/support"
      />
      <main className="support">
        <h1>Coming soon...</h1>
      </main>
    </>
  );
}

export default App;
